import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const ArrowRightIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue5c8'}</MuiIcon>
    );
}
